import { render } from "./ViewHome.vue?vue&type=template&id=3097a1a0&scoped=true"
import script from "./ViewHome.vue?vue&type=script&lang=js"
export * from "./ViewHome.vue?vue&type=script&lang=js"

import "./ViewHome.vue?vue&type=style&index=0&id=3097a1a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3097a1a0"]])

export default __exports__